import React, { Component } from 'react';
import { connect } from "react-redux";
import { ConfirmationView, DeclinedView, SignUpCreatePassword, ApplicationProcessingView } from "../subcomponents"
import { newLoanActions } from "../../_actions";
import { userService, newLoanService, LeadService, workflowService } from "../../_services";
import { workflowConstants } from '../../_constants';

class Confirmation extends Component {
    static displayName = Confirmation.name;

    constructor(props) {
        super(props);
        this.decisionDelay = 3000;
        this.decisionTimeout = 60000;
        this.state = {
            reachedTimeout: false,
            decision: undefined,
            disclosureMessage: "",
            existingCustomerFlow: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getDecision = this.getDecision.bind(this);
    }

    getDecision(userHash, leadId) {
        newLoanService.getLeadDecision(userHash, leadId).then(decisionResult => {
            let newDecision = decisionResult.data;

            if (newDecision && newDecision.hasDecision) {
                const lang = userService.getUserLanguage().toLowerCase();
                const disclosureMessage = lang === "es" ? this.props.disclosure.spanishText : this.props.disclosure.englishText;

                this.setState({ decision: newDecision, disclosureMessage });
            } else if (this.state.reachedTimeout) {
                this.setState({ decision: null });
            } else {
                setTimeout(this.getDecision, this.decisionDelay, userHash, leadId);
            }
        });
    }

    componentDidMount() {
        let workflowData = workflowService.getCurrentWorkflowStepData()

        if (workflowData.workflowId === workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW) {
            this.setState({ decision: null, existingCustomerFlow: true });
        }
        else if (this.props.userHash && this.props.leadId) {
            setTimeout(() => this.setState({ reachedTimeout: true }), this.decisionTimeout);
            setTimeout(this.getDecision, this.decisionDelay, this.props.userHash, this.props.leadId);
        } else {
            this.setState({ decision: null });
        }
    }

    handleSubmit() {
        const { dispatch } = this.props;

        dispatch(newLoanActions.confirmation());
    }

    render() {
        if (this.state.existingCustomerFlow) {
            return <ConfirmationView sunLoanBranchId={this.props.BranchId} onDone={this.handleSubmit} />
        }

        if (this.state.decision === undefined) {
            return <ApplicationProcessingView />
        } 

        if (this.state.decision !== null && this.state.decision.status === LeadService.LEAD_DECLINED) {
            return <DeclinedView disclosure={this.state.disclosureMessage} />
        }

        if (this.state.decision !== null && this.state.decision.targetLoan > 0) {
            return <SignUpCreatePassword preapprovedAmount={this.state.decision.targetLoan} requestedAmount={this.state.decision.requestedAmount} />
        }

        return <SignUpCreatePassword />
    }
}


function mapStateToProps(store) {
    const { error, errorString, branchId, leadId, userHash } = store.newLoan;
    const { disclosure, language } = store.users;

    return {
        error, errorString, branchId, leadId, userHash, disclosure, language
    };
}

const connectedConfirmation= connect(mapStateToProps)(Confirmation);
export { connectedConfirmation as Confirmation };